import { render, staticRenderFns } from "./CreativesForm.vue?vue&type=template&id=8bdf28cc"
import script from "./CreativesForm.vue?vue&type=script&lang=js"
export * from "./CreativesForm.vue?vue&type=script&lang=js"
import style0 from "./CreativesForm.vue?vue&type=style&index=0&id=8bdf28cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports